import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormControl, NgModel } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, T4Image, ImageType, T4InvoiceInfo, T4CCService, T4InvoiceLine, OrderEntityEventInfo, OrderEntityType, T4InvoiceDocumentsInfo } from 't4core';
import * as uuid from 'uuid';
import { T4DatatableWidget } from '../../../../t4common';
import { CreditInvoiceDialog } from '../CreditInvoiceDialog/CreditInvoiceDialog';

@Component({
  selector: 'InvoiceDetails',
  templateUrl: 'InvoiceDetails.html',
  styleUrls: ['./InvoiceDetails.css']
})
export class InvoiceDetailsDialog extends DialogBase {

  public invoiceId: string = "";
  public invoice: T4InvoiceInfo;
  public invoiceLines: T4InvoiceLine[] = [];
  public invoiceDocuments: T4InvoiceDocumentsInfo[] = [];
  public entityEvents: OrderEntityEventInfo[] = [];
  public isLoading: boolean = false;
  @ViewChild("tblInvoiceLines", { static: false }) tblInvoiceLines: T4DatatableWidget;

    constructor(
      public dialogRef: MatDialogRef<InvoiceDetailsDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any,
        private svc: T4CCService
    ) {
      super("InvoiceDetailsDialog");
      if (this.data && this.data.invoiceId) {
        this.invoiceId = this.data.invoiceId;
        this.loading = true;
        this.loadInvoiceInfo();
        this.loading = false;
      }
      
    }

  public async ngOnInit() {
  }

  public async loadInvoiceInfo() {
    this.isLoading = true;
    this.invoice = await this.svc.GetInvoiceDetails(this.invoiceId);
    this.entityEvents = await this.Api.get<OrderEntityEventInfo[]>("TurboOrder/GetEntityEvents", { entityId: this.invoiceId, entityType: OrderEntityType.Customer, eventType: 4 });
    this.invoiceLines = this.invoice?.AggregatedLines;
    this.invoiceDocuments = this.invoice?.InvoiceDocuments;
    this.isLoading = false;
    
  }

    public save() {
        this.dialogRef.close(this.data);
  }

  public anyChecked(): boolean {
    return this.tblInvoiceLines && this.tblInvoiceLines.data.renderedData.filter(function (n, i) {
      return n.Credit;
    }).length > 0;
  }

  public async createCreditInvoice() {
    var rows = this.tblInvoiceLines.data.renderedData.filter(function (n, i) { return n.Credit; });

    this.Dialog.open(CreditInvoiceDialog, {
      data: {
        InvoiceId: this.invoiceId,
        InvoiceLines: rows
      }
    }).afterClosed().subscribe(async () => {
      await this.loadInvoiceInfo();
      this.tblInvoiceLines.update();
    });
  }

  public async deleteRow(row: T4InvoiceLine) {
    if (row.Price <= row.CreditedAmount) {
      this.UI.alert("Turbo.Order.InvoiceDetailsDialog.alertNoCredit", "No Credit", "Turbo.Order.InvoiceDetailsDialog.alertMsgNoCredit", "There is no amount to credit for this product.");
      return;
    }

    var x = await this.UI.confirm('Turbo.Order.InvoiceDetailsDialog.headConfirmDelete', 'Confirm deletion', 'Turbo.Order.InvoiceDetailsDialog.msgConfirmDelete', 'Are you sure you want to delete the invoice lines for this product?');
    if (!x) return;

    if (row.ProductId) {
      var note = await this.UI.prompt("Turbo.Order.InvoiceDetailsDialog.promptCommentHeadline", "Add comment", "Turbo.Order.InvoiceDetailsDialog.promptCommentQuery", "Add your comment here.");
      this.isLoading = true;
      if (await this.Api.delete<boolean>("/CC/DeleteInvoiceLines", { invoiceId: this.invoiceId, productId: row.ProductId, productName: row.ProductName, comment: note })) {
        await this.loadInvoiceInfo();
        this.tblInvoiceLines.update();
      } else {
        await this.UI.alert('Turbo.Order.InvoiceDetailsDialog.headDeleteFailed', 'Delete failed', 'Turbo.Order.InvoiceDetailsDialog.msgDeleteFailed1', 'Invoice line could not be cancelled. This is either already cancelled or some error occured. Please try again later.');
      }
      this.isLoading = false;
    }
  }
}
